var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendixLogoNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 763.76 314.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fbbb2e;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AttendixLogoNav") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Attendix_Dark_2",
    "data-name": "Attendix Dark 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Attendix"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.26,
    cy: 37.66,
    r: 37.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.45,191.11s-.84-41.84,70.7-55.64c84.1-16.23,72.38-70.71,72.38-70.71s-6.26,31-90.79,31C11.09,95.72,18.62,135.05,37.45,191.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28,314.12S16.53,272.56,83.75,243c70.35-30.94,49.64-88.17,49.64-88.17s2.18,34-80,53.59C-21.69,226.26-5.23,261.4,28,314.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.22,204.11H236.29l-8.41,20.69H207.31l39.37-95.28h20.2l39.37,95.28H285.59Zm-6.67-16.6-13.8-34-13.79,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331,174v18.65c0,5.44,1.08,9.35,3.25,11.7s5.74,3.54,10.7,3.54v17.29q-15.66,0-24.88-8t-9.19-24.53V174h-11.5V156.74h11.5V129.65H331v27.09h14V174Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.6,174v18.65c0,5.44,1.08,9.35,3.25,11.7s5.74,3.54,10.7,3.54v17.29q-15.66,0-24.88-8t-9.22-24.5V174H349V156.74h11.47V129.65H380.6v27.09h13.95V174Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M405.17,173.46a37.55,37.55,0,0,1,14.26-13,41.7,41.7,0,0,1,19.91-4.83,47.1,47.1,0,0,1,19.07,4,38.73,38.73,0,0,1,15.11,11.64,29.89,29.89,0,0,1,6.28,18,37.89,37.89,0,0,1-.62,8.44H421.67a13.25,13.25,0,0,0,6.13,8,21.5,21.5,0,0,0,11.54,2.92,23.61,23.61,0,0,0,7.83-1.08,22.67,22.67,0,0,0,5.5-2.86l24,.13a37.3,37.3,0,0,1-14.73,15.25,42.42,42.42,0,0,1-22,5.85,43.38,43.38,0,0,1-20.15-4.7,37.81,37.81,0,0,1-14.47-12.76A31,31,0,0,1,400,190.9,31.71,31.71,0,0,1,405.17,173.46Zm53.08,10.14a18,18,0,0,0-7.36-7.69A21.43,21.43,0,0,0,440,173a20.88,20.88,0,0,0-11.16,2.86,18.92,18.92,0,0,0-7.13,7.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M556.52,224.8H536.37V189q0-8.28-3.33-12.18t-10.62-3.88q-7.27,0-10.61,3.88T508.47,189v35.8H488.32V189q0-16.59,9.3-25t24.8-8.37q15.51,0,24.81,8.37t9.29,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M639.53,208.4A37.62,37.62,0,0,1,625,221.19a44.88,44.88,0,0,1-40,0,38.09,38.09,0,0,1-14.57-12.79,31.37,31.37,0,0,1,0-35.26A38.17,38.17,0,0,1,585,160.35a43.27,43.27,0,0,1,20-4.7q11.31,0,19.53,5.18V129.52h20.31v61.25A31.44,31.44,0,0,1,639.53,208.4ZM590.78,178a17.31,17.31,0,0,0-1,24.46c.32.35.65.68,1,1a20.06,20.06,0,0,0,14.11,5.1,20.65,20.65,0,0,0,14.25-5.1,17,17,0,0,0,1.46-24,20.11,20.11,0,0,0-1.46-1.46,20.7,20.7,0,0,0-14.25-5.1A20.15,20.15,0,0,0,590.78,178Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M660.76,146.46a9.71,9.71,0,0,1-3.49-7.56,9.52,9.52,0,0,1,3.49-7.42,12.59,12.59,0,0,1,8.6-3.06,12.42,12.42,0,0,1,8.45,3.06,9.55,9.55,0,0,1,3.49,7.42,9.69,9.69,0,0,1-3.49,7.56,12.33,12.33,0,0,1-8.45,3.06A12.59,12.59,0,0,1,660.76,146.46Zm-1.47,10.27h20.15v68.06H659.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M741,224.8l-16-20.69-16.1,20.69H686l27.59-35.34-25.27-32.67h22.61l14,18.11L739,156.79h22.63l-25.3,32.67,27.44,35.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.09,18a18.13,18.13,0,1,0,18.13,18.13A18.13,18.13,0,0,0,181.09,18Zm9.36,13.67L178.75,43.4a1.91,1.91,0,0,1-2.69,0l-4.28-4.28a1.91,1.91,0,0,1,2.7-2.69l2.93,2.92L187.75,29a1.91,1.91,0,1,1,2.7,2.7Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendixLogoNav);
export default __webpack_public_path__ + "static/media/AttendixLogoNav.6c2c8b80b8667ee00be9809b0a6c774d.svg";
export { ForwardRef as ReactComponent };